import type { FunctionComponent } from 'react';
import { usePushNotifications } from '@media-platform/push-notifications-tooltip/src/hooks/usePushNotifications';
import { getWorker } from '@media-ui/core/src/tools/swInstaller/swInstaller';
import { logger } from '../utils/utils';

import type * as T from './PushNotifications.types';

const PushNotifications: FunctionComponent<T.IPushNotifications> = (props) => {
  const { application, workerKey, workers } = props;

  const { createPushNotifications } = usePushNotifications({
    componentsProps: {
      onMount: (element) => logger.attachChildren(element as HTMLElement),
    },
    modelEvents: {
      ready: (data) => logger.ready(data as T.IStateWithPermission),
      error: () => logger.error(),
      subscribe: () => logger.subscribe(),
      unsubscribe: () => logger.unsubscribe(),
    },
    modelOptions: {
      application: application || 'pets',
      allowedPlatforms: ['Chrome', 'Firefox'],
      serverUrl: '/api-proxy/browserpush/register/',
      workerInstaller: getWorker({
        workerKey: workerKey || 'sw-common',
        workers: workers || {
          'sw-common': '/sw-common.js',
        },
      }),
    },
    useLocalStorageTimemark: true,
    targetContainer: document.body,
  });

  return <>{createPushNotifications()}</>;
};

export default PushNotifications;
